'use client';
import { parseBasicQuery } from './parsers/parseBasicQuery.js';
import { parseSegmentQuery } from './parsers/parseSegmentQuery.js';

var transformExtendedQuery = function(query, units, noMediaKeyword) {
    return function(theme) {
        var _parseBasicQuery = parseBasicQuery(query), isValidBasicQuery = _parseBasicQuery.isValid, size = _parseBasicQuery.size, fn = _parseBasicQuery.fn;
        if (isValidBasicQuery) {
            return theme.fn[fn](size, units, noMediaKeyword);
        }
        var segmentResult = parseSegmentQuery(query);
        if (segmentResult) {
            var from = segmentResult.from, to = segmentResult.to;
            return theme.fn.between(from, to, units, noMediaKeyword);
        }
    };
};

export { transformExtendedQuery };
